import { render, staticRenderFns } from "./ot-switch.vue?vue&type=template&id=1cd87ae6&scoped=true&"
import script from "./ot-switch.vue?vue&type=script&lang=ts&"
export * from "./ot-switch.vue?vue&type=script&lang=ts&"
import style0 from "./ot-switch.vue?vue&type=style&index=0&id=1cd87ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd87ae6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
